import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';

import { SKIP_ERROR_TOAST, SKIP_LOADING_INDICATOR } from '@/shared/lib/core/interceptors/header-tokens';

import { apiEndpoint } from '../../constants/endpoints.const';
import { SignalRConnectionInfo } from '../../interfaces/account/signal-r-connection-info';

@Service()

export class SignalRApi {
    http = inject(HttpClient);

    getSignalRToken(): Observable<SignalRConnectionInfo> {
        return this.http.get<SignalRConnectionInfo>(`${apiEndpoint}/signalr/connect/byheader`, {
            context: new HttpContext().set(SKIP_LOADING_INDICATOR, true).set(SKIP_ERROR_TOAST, true),
        });
    }
}
